import { render, staticRenderFns } from "./CmgTaxAndFees.vue?vue&type=template&id=267dc0aa&scoped=true&lang=pug&"
import script from "./cmg-tax-and-fees.ts?vue&type=script&lang=ts&"
export * from "./cmg-tax-and-fees.ts?vue&type=script&lang=ts&"
import style0 from "./CmgTaxAndFees.vue?vue&type=style&index=0&id=267dc0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267dc0aa",
  null
  
)

export default component.exports